import styled from '@emotion/styled';
import {col, fontWeight} from '@styles/helpers';
import AttenderLogo from '@assets/svg/logo.svg';
import {useAuthentication} from '@providers/AuthProvider';
import {colors} from '@styles/colors';
import BreathableAnim from '@components/Animation/BreathableAnim';
import {absoluteCenter} from '@styles/reusable';
import { useI18n } from '@i18n/useI18n';
import { useStore } from '@store/appStore';
import { CustomButton } from '../ErrorPage/ErrorPage.styled';

const image = 'phones.jpg';

const ImageContainer = styled.div`
  width: ${col(4, 12)};
`;

const Wrapper = styled.div`
  ${absoluteCenter}
  width: var(--site-width);
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.mainTextColor};

  p {
    font-size: 18px;
    margin: 10px 0;
    font-weight: ${fontWeight.light};
  }
`;

export const Logo = styled(AttenderLogo)`
  height: 30px;
  width: auto;
`;

export const LoginScreen = () => {
  const { login } = useAuthentication();
  const {
    popupLogin
    } = useStore();
  const i18 = useI18n()
  return (
    <Wrapper>
      {/* <ImageContainer> */}
      {/* </ImageContainer>  */}
      <TextContainer>
        <Logo />
        {!popupLogin ? <p>{i18.t('loggingin')} <BreathableAnim /></p> : <CustomButton mobile={true} small={false} onClick={(e) => login(e, true)}>{i18.t('Login')}</CustomButton> }
      </TextContainer>
    </Wrapper>
  );
};

export default LoginScreen;
